import axios from '../../../helpers/axios'
import { IExam } from '../../../types'

export default {
  async uploadQuestionFile(context: IExam, payload: {file: File}): Promise<any> {
    const formData = new FormData()
    formData.append('file', payload.file)
    const response = await axios().post(context.endpoints.import,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    return response.data
  }
}
